module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-right-af321abda7207a37eb12fc099f6b027f.svg";